import request from "services/Request"
import { serializeCountries } from "types/Country"

export function getCountries() {
	return request({
		url: `/shop/countries`,
		method: 'GET',
	}, serializeCountries)
}